import { queryClient } from "../query-client";
import { queryKeys } from "../query-keys";

/** Get proId from the cached pro/me query data */
export function getCachedProId(): string | null {
	const data = queryClient.getQueryData<{ proId?: string }>(
		queryKeys.pro.me(),
	);
	return data?.proId ?? null;
}

export const STALE_2MIN = 1000 * 60 * 2;
export const STALE_5MIN = 1000 * 60 * 5;
export const STALE_1HR = 1000 * 60 * 60;
